import React from 'react';
import { formatCurrency } from "../../utils/CurrencyUtils";
import { FaUser, FaShoppingBag, FaReceipt, FaWallet, FaTrash, FaUserPlus, FaCartPlus, FaMoneyBillWave, FaCalendarAlt } from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";

const OrderSummary = ({
    reservationDate,
    order,
    customer,
    selectedProducts = [],
    itemCount = 0,
    totalAmount = 0,
    change = 0, 
    totalReceived = 0,
    onUpdateQuantity
}) => {

    const formatDate = (dateStr) => {
        if (!dateStr) return "---";
        const cleanDate = dateStr.includes('T') ? dateStr.split('T')[0] : dateStr;

        if (cleanDate.includes('/')) return cleanDate.split(' ')[0];
        
        if (cleanDate.includes('-')) {
            try {
                const [y, m, d] = cleanDate.split("-").map(Number);
                const date = new Date(y, m - 1, d);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            } catch {
                return cleanDate;
            }
        }
        return cleanDate;
    };

    const hasCustomer = customer && customer.name;

    return (
        <div className="flex justify-center w-full px-2 md:px-0 pb-10 h-full">
            <div className="w-full bg-white rounded-2xl shadow-xl overflow-hidden border border-slate-100 flex flex-col h-full animate-in fade-in zoom-in duration-300">

                {/* --- CABEÇALHO --- */}
                <div className={`${hasCustomer ? 'bg-custom_blue' : 'bg-slate-400'} p-6 text-white text-center relative transition-colors duration-500`}>
                    <div className="absolute top-4 right-4 opacity-20">
                        <FaReceipt size={40} />
                    </div>
                    <h2 className="text-2xl font-bold tracking-wide">Resumo</h2>
                    <p className="text-blue-50 text-sm mt-1">
                        {hasCustomer ? "Confira os itens abaixo" : "Aguardando dados..."}
                    </p>
                </div>

                <div className="p-6 space-y-6 flex-1 overflow-y-auto">

                    {/* DADOS BÁSICOS (Aluno/Data) */}
                    <div className="flex flex-col gap-4">
                        <div className={`flex items-center p-3 rounded-xl border transition-all ${hasCustomer ? 'bg-gray-50 border-gray-100' : 'bg-slate-50 border-dashed border-slate-300'}`}>
                            <div className={`p-3 rounded-full mr-3 ${hasCustomer ? 'bg-blue-100 text-custom_blue' : 'bg-slate-200 text-slate-400'}`}>
                                {hasCustomer ? <FaUser /> : <FaUserPlus />}
                            </div>
                            <div className="flex-1">
                                <p className="text-xs text-gray-500 uppercase font-bold">Aluno</p>
                                <p className={`font-bold text-lg leading-tight ${hasCustomer ? 'text-gray-800' : 'text-slate-400 italic'}`}>
                                    {hasCustomer ? customer.name : "Selecione um aluno..."}
                                </p>
                            </div>
                        </div>

                        {/* --- DATA (Restaurada Aqui) --- */}
                        <div className="flex items-center p-3 bg-gray-50 rounded-xl border border-gray-100">
                            <div className={`p-3 rounded-full mr-3 ${reservationDate ? 'bg-orange-100 text-orange-500' : 'bg-gray-200 text-gray-400'}`}>
                                <FaCalendarAlt />
                            </div>
                            <div>
                                <p className="text-xs text-gray-500 uppercase font-bold">Data do Pedido</p>
                                <p className="font-bold text-gray-800 text-lg capitalize">
                                    {formatDate(reservationDate)}
                                </p>
                            </div>
                        </div>
                    </div>

                    <hr className="border-dashed border-gray-300" />

                    {/* PRODUTOS */}
                    <div className="flex-1 flex flex-col">
                        <div className="flex items-center gap-2 mb-3 text-gray-700">
                            <FaShoppingBag />
                            <h3 className="font-bold text-lg">Itens ({itemCount})</h3>
                        </div>
                        {selectedProducts.length === 0 ? (
                            <div className="flex flex-col items-center justify-center h-32 border-2 border-dashed border-slate-200 rounded-xl bg-slate-50 text-slate-400">
                                <FaCartPlus size={24} className="mb-2 opacity-50"/>
                                <span className="text-sm font-medium">Carrinho vazio</span>
                            </div>
                        ) : (
                            <div className="bg-gray-50 rounded-xl p-3 max-h-80 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent">
                                {selectedProducts.map((p, index) => (
                                    <div key={index} className="flex flex-col sm:flex-row sm:items-center justify-between mb-3 last:mb-0 border-b last:border-0 border-gray-200 pb-3 last:pb-0 border-dashed gap-3">
                                        <div className="flex-1">
                                            <p className="font-bold text-gray-800 text-sm leading-tight">{p.name}</p>
                                            <p className="text-xs text-gray-500 mt-1">{formatCurrency(p.price)} un.</p>
                                        </div>
                                        <div className="flex items-center justify-between sm:justify-end gap-4">
                                            {onUpdateQuantity && (
                                                <div className="flex items-center bg-white border border-gray-300 rounded-lg h-8 shadow-sm">
                                                    <button onClick={() => onUpdateQuantity(p, p.quantity === 1 ? 'remove' : 'minus')} className="w-8 h-full flex items-center justify-center text-gray-600 hover:bg-gray-100 hover:text-red-500 rounded-l-lg border-r">
                                                        {p.quantity === 1 ? <FaTrash size={12} /> : <AiOutlineMinus size={12} />}
                                                    </button>
                                                    <span className="w-8 text-center text-sm font-bold text-gray-800">{p.quantity}</span>
                                                    <button onClick={() => onUpdateQuantity(p, 'plus')} className="w-8 h-full flex items-center justify-center text-gray-600 hover:bg-gray-100 hover:text-green-600 rounded-r-lg border-l">
                                                        <AiOutlinePlus size={12} />
                                                    </button>
                                                </div>
                                            )}
                                            <p className="font-bold text-gray-800 text-sm min-w-[70px] text-right">
                                                {formatCurrency(p.price * p.quantity)}
                                            </p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    <hr className="border-dashed border-gray-300" />

                    {/* --- PAGAMENTO --- */}
                    <div className="space-y-3">
                        <div className="flex items-center gap-2 text-gray-700 mb-2">
                            <MdPayment size={20} />
                            <h3 className="font-bold text-lg">Pagamento</h3>
                        </div>

                        {(!order?.transactions || order.transactions.length === 0) ? (
                             <p className="text-sm text-slate-400 italic bg-slate-50 p-2 rounded border border-dashed">Nenhum método selecionado</p>
                        ) : (
                            order.transactions.map((t, index) => (
                                <div key={index} className="flex justify-between items-center text-sm">
                                    <span className="text-gray-600 font-medium bg-gray-100 px-2 py-1 rounded text-xs uppercase tracking-wide">
                                        {t.paymentMethod ? t.paymentMethod.split('/')[0] : '---'}
                                        {t.paymentMethod && t.paymentMethod.split('/')[1] ? ` (${t.paymentMethod.split('/')[1]})` : ''}
                                    </span>
                                    <span className="font-semibold text-gray-800">{formatCurrency(t.value || t.received_value)}</span>
                                </div>
                            ))
                        )}

                        {/* EXIBIÇÃO DO TROCO */}
                        {change > 0 && (
                            <div className="flex items-center justify-between p-3 bg-yellow-50 border border-yellow-200 rounded-lg text-yellow-800 animate-in zoom-in">
                                <div className="flex items-center gap-2">
                                    <FaMoneyBillWave />
                                    <span className="font-bold text-sm uppercase">Troco</span>
                                </div>
                                <span className="font-bold text-lg">{formatCurrency(change)}</span>
                            </div>
                        )}

                        {hasCustomer && (
                             <div className="mt-4 pt-3 border-t border-gray-100 flex justify-between items-center">
                                <div className="flex items-center gap-2 text-xs text-gray-500 font-medium">
                                   <FaWallet />
                                   <span>Saldo atual:</span>
                                </div>
                                <span className={`text-sm font-bold ${customer?.credit <= 0 ? "text-red-500" : "text-green-600"}`}>
                                   {formatCurrency(customer?.credit ?? 0)}
                                </span>
                           </div>
                        )}
                    </div>
                </div>

                {/* --- FOOTER TOTAL --- */}
                <div className="bg-gray-900 p-6 flex justify-between items-center text-white mt-auto">
                    <div className="flex flex-col">
                        <span className="text-gray-400 text-xs uppercase font-bold tracking-wider">Valor Total</span>
                        <span className="text-sm text-gray-400">{itemCount} itens</span>
                    </div>
                    <div className="text-3xl font-bold tracking-tight">
                        {formatCurrency(totalAmount)}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderSummary;